import {call, put, takeLatest} from 'redux-saga/effects'
import {USER_LOGIN, userLoginSuccess} from '../redux/actions/user'
import {
  MEMBER_LOGIN,
  memberLoginSuccess,
  UPDATE_MEMBER_INFO,
  updateMemberInfoSuccess,
} from '../redux/actions/member'
import {push} from 'connected-react-router'
import {
  getListingType,
  getSetting,
  userLogin,
  apiApplessRegister,
  apiApplessProfileUpdate,
} from '../utilities/ApiManage'
import {setAccessToken} from '../utilities/NetworkingAuth'
import {toast} from 'react-toastify'
import {
  getAppSettingsSuccess,
  getListingTypeSuccess,
  setShowGlobalIndicator,
  setPopupMessage,
} from '../redux/actions/app'

function* sessionLoginSaga(action) {
  try {
    yield put(setShowGlobalIndicator(true))
    let body = {email: action.firstParam, password: action.secondParam}
    if (action.mode === 'crmUser') {
      body = {code: action.firstParam, state: action.secondParam}
    }
    const res = yield call(userLogin, body)
    if (!res.ok) throw new Error(res.message)
    yield put(userLoginSuccess({...res.user, token: res.token, flags: res.user.roles[0].control}))
    setAccessToken(res.token)
    //Get listing
    const listingType = yield call(getListingType)
    if (listingType.ok) yield put(getListingTypeSuccess(listingType.data))

    //Get settings and sso version
    const settings = yield call(getSetting)
    if (settings.ok) {
      yield put(getAppSettingsSuccess(settings.data?.reduce((acc, item) => ({...acc, [item.key]: item}), {})))
    }
    yield put(push('/welcome'))
  } catch (e) {
    toast({warning: e.message})
  } finally {
    yield put(setShowGlobalIndicator(false))
  }
}

function* memberLoginSaga(action) {
  try {
    const body = {mobile: action.mobile, otp_code: action.otp, captcha_token: action.recapchaToken}
    const res = yield call(apiApplessRegister, body)
    if (!res.ok) throw new Error(res.message)
    yield put(memberLoginSuccess({...res.member, token: res.token}))
    setAccessToken(res.token)
    yield put(push('/profile'))
  } catch (e) {
    yield put(setPopupMessage(`Error: ${e.message}`))
  } finally {
    yield put(setShowGlobalIndicator(false))
  }
}

function* memberUpdateSaga(action) {
  try {
    yield put(setShowGlobalIndicator(true))
    const res = yield call(apiApplessProfileUpdate, action.payload)
    if (!res.ok) throw new Error(res.message)
    yield put(updateMemberInfoSuccess({...res.member, token: res.token}))
    setAccessToken(res.token)
    yield put(setPopupMessage("Your profile has been updated."))
  } catch (e) {
    yield put(setPopupMessage(`Error: ${e.message}`))
  } finally {
    yield put(setShowGlobalIndicator(false))
  }
}

export default [
  takeLatest(USER_LOGIN, sessionLoginSaga),
  takeLatest(MEMBER_LOGIN, memberLoginSaga),
  takeLatest(UPDATE_MEMBER_INFO, memberUpdateSaga),
]
